import { StateCreator } from "zustand";

export enum EEmailFormState {
  initial,
  validating,
  validated,
  submitting,
  waitingForStatus,
  submitted,
}

export interface IEmailFormSlice {
  email: string;
  emailFormState: EEmailFormState;
  errorMessage: string;
  setEmail: (email: string) => void;
  clearEmailForm: () => void;
  setEmailFormState: (state: EEmailFormState) => void;
  setErrorMessage: (errorMessage: string) => void;
}

/**
 * Contains all information about email form.
 */
export const emailFormSliceCreator: StateCreator<IEmailFormSlice> = set => ({
  email: "",
  errorMessage: "",
  emailFormState: EEmailFormState.initial,
  setEmail: (email) => {
    set(() => ({
      email: email,
    }));
  },
  clearEmailForm: () => {
    set(() => ({
      email: "",
      emailFormState: EEmailFormState.initial,
      errorMessage: "",
    }));
  },
  setEmailFormState: (state: EEmailFormState) => {
    set(() => ({ emailFormState: state }));
  },
  setErrorMessage: (message) => {
    set(() => ({ errorMessage: message }));
  },
});
